import { render, staticRenderFns } from "./koulutusjakso.vue?vue&type=template&id=a1edc220&scoped=true&"
import script from "./koulutusjakso.vue?vue&type=script&lang=ts&"
export * from "./koulutusjakso.vue?vue&type=script&lang=ts&"
import style0 from "./koulutusjakso.vue?vue&type=style&index=0&id=a1edc220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1edc220",
  null
  
)

export default component.exports